import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

export const locale = ['es', 'ca', 'en']

export interface LocaleTypes {
  en: string
  es: string
  ca: string
}

export const LOCALE_TYPES: LocaleTypes = {
  en: 'en-US',
  es: 'es-ES',
  ca: 'ca-ES',
}

// Organize translations by language and namespace
const translations = import.meta.glob('/public/locales/**/*.json', { eager: true })

// Organize translations by language and namespace
const resources: Record<string, Record<string, any>> = {}

Object.entries(translations).forEach(([path, module]: [string, any]) => {
  // Catch: /public/locales/{language}/...
  const match = path.match(/\/locales\/([^/]+)\//)
  if (match) {
    const lngFolder = match[1] // ca-ES, en-US, es-ES
    const shortLng = lngFolder.split('-')[0].toLowerCase() // es, ca, en
    
    if (!resources[shortLng]) {
      resources[shortLng] = { translation: {} }
    }
    
    // Merge all files into the 'translation' namespace
    const content = module.default || module
    resources[shortLng].translation = {
      ...resources[shortLng].translation,
      ...content
    }
  }
})

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    defaultNS: 'translation',
    supportedLngs: ['es', 'en', 'ca'],
    load: 'languageOnly',
    cleanCode: true,
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  },
    (err, t) => {
      if (err) {
        return console.log('something went wrong loading', err) // eslint-disable-line no-console
      }
      t('key')
    },
  )

export default i18n